// extracted by mini-css-extract-plugin
export var columnItem = "_bo-3";
export var columnItemDraggable = "_bo-4";
export var dragHandle = "_bo-0";
export var dragHandleHovered = "_bo-1";
export var dropdown = "_bo-5";
export var dropdownContent = "_bo-7";
export var dropdownInner = "_bo-6";
export var filterDropdownHeader = "_bo-8";
export var icon = "_bo-2";
export var sectionDivider = "_bo-9";